/**
 * Debounce 경계 (rules.md §7).
 *
 * 마지막 호출 뒤 delayMs 동안 추가 호출이 없으면 콜백을 한 번 실행한다. 검색·필터처럼
 * 사용자 입력으로 빠르게 반복되는 동작을 한 번의 요청으로 묶는다(network round-trip 절약).
 *
 * 타이머 생명주기만 소유한다. query 정규화·pending 상태 같은 도메인 로직은 호출자가 소유한다.
 */
export type DebouncedAction = {
  /** 콜백을 delayMs 뒤에 실행하도록 예약한다. 대기 중에 또 호출되면 이전 예약을 취소하고 다시 예약한다. */
  schedule(callback: () => void): void;
  /** 예약된 콜백을 취소한다. dispose 또는 즉시 commit 직전에 호출한다. */
  cancel(): void;
};

export function createDebouncedAction(delayMs: number): DebouncedAction {
  let timer: ReturnType<typeof setTimeout> | null = null;

  function cancel(): void {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  }

  return {
    schedule(callback: () => void): void {
      cancel();
      timer = setTimeout(() => {
        timer = null;
        callback();
      }, delayMs);
    },
    cancel,
  };
}
